<template>
    <div>
        <div>
            <div class="form-single">
                <div class="title">修改日期</div>
                <div class="content">
                    <el-radio-group v-model="modifyTime">
                        <el-radio :label=false>否</el-radio>
                        <el-radio :label=true>是</el-radio>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <div :class="{'display-none' : !modifyTime}">
            <div class="form-single" v-if="state < biding ">
                <div class="title">报名截止时间</div>
                <div class="content">
                    <el-date-picker v-model="callBidDocInfo.enrollCloseTime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm" :picker-options="pickerOptions0"></el-date-picker>
                </div>
            </div>
            <div class="form-single" v-if="state < biding ">
                <div class="title">资格预审结束</div>
                <div class="content">
                    <el-date-picker v-model="callBidDocInfo.openTime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm" :picker-options="pickerOptions0"></el-date-picker>
                </div>
            </div>
            <div class="form-single" v-if="state < openBid ">
                <div class="title">投标截止时间</div>
                <div class="content">
                    <el-date-picker v-model="callBidDocInfo.closeTime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm" :picker-options="pickerOptions0"></el-date-picker>
                </div>
            </div>
            <div class="form-single" v-if="state <= openBid ">
                <div class="title">公布结果时间</div>
                <div class="content">
                    <el-date-picker v-model="callBidDocInfo.resultPublishTime" type="datetime" placeholder="选择日期时间" format="yyyy-MM-dd HH:mm" :picker-options="pickerOptions0"></el-date-picker>
                </div>
            </div>
        </div>

        <div class="form-single" v-if="(initial < state) && (state< biding) ">
            <div class="title">修改招标附件</div>
            <div class="content">
                <el-radio-group v-model="modifyFile">
                    <el-radio :label=false>否</el-radio>
                    <el-radio :label=true>是</el-radio>
                </el-radio-group>
            </div>
        </div>

        <div :class="{'display-none' : !modifyFile}">
            <div class="content-caption dashed bg-white">
                <span>附件信息</span>
            </div>
            <div class="form-single">
                <div class="title" style="text-align: left">上传招标书</div>
                <div class="content">
                    <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                    <div class="file-area clearfix">
                        <swb-file-item v-for="(file, index) in fileList" :trackKey="index" :fileName="file.name" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl" :fileDownloadUrl="file.fileDownloadUrl" :fileMd5="file.fileMd5" :deletable="true" :onDelete="removeUpload"></swb-file-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import callBidApi from '../../api/callBid'

    import SwbCkEditor from '../ctrl/CkEditor';
    Vue.regist(SwbCkEditor);

    export default {
        name: 'swb-call-bid-notice-publish',
        desc: '发布招标公告',
        props: ['docId', 'state'],
        data: function () {
            return {
                callBidDocInfo: {},
                initialEnrollCloseTime: null,
                initialOpenTime: null,
                initialCloseTime: null,
                initialResultPublishTime: null,
                date: new Date(),
                modifyTime: false,
                modifyFile: false,
                initial: null,
                currState: null,
                fileList: [],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                }
            }
        },
        created: function () {
            this.biding = getEnumInfoWith('callBidDocState', 'name', 'Biding').value;
            this.currState = this.state;
            this.openBid = getEnumInfoWith('callBidDocState', 'name', 'OpenBid').value;
            this.initial = getEnumInfoWith('callBidDocState', 'name', 'Initial').value;
            this.getCallBidDoc();
        },
        methods: {
            getCallBidDoc: function () {
                let self = this;
                let postData = {};
                postData.id = self.docId;
                let lastMsgBoxDlg = MsgBox.loading();
                callBidApi.getCallBidDocInfo(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let callBidDocInfo = result.data;
                        self.initialEnrollCloseTime = callBidDocInfo.enrollCloseTime;
                        self.initialOpenTime = callBidDocInfo.openTime;
                        self.initialCloseTime = callBidDocInfo.closeTime;
                        self.initialResultPublishTime = callBidDocInfo.resultPublishTime;
                        self.callBidDocInfo = callBidDocInfo;
                        self.fileList = self.callBidDocInfo.callBidFileList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) { // for 处理多文件上传...
                        let file = files[i];
                        let callBidFile = {};
                        callBidFile.name = file.fileName;
                        callBidFile.fileUuid = file.fileUuid;
                        callBidFile.fileExtName = file.fileExtName;
                        callBidFile.fileBrowseUrl = file.fileBrowseUrl;
                        callBidFile.fileDownloaddUrl = file.fileDownloadUrl;
                        callBidFile.fileMd5 = file.fileMd5;
                        self.fileList.push(callBidFile);
                    }
                } else {
                    this.$message.success(result.message);
                }
            },

            downloadDemoFile: function (fileDownloadUrl) {
                Utils.downloadFile(getAppUrl(fileDownloadUrl));
            },

            removeUpload: function (index) {
                this.fileList.removeAt(index.trackKey);
                return false;
            },

            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let callBidNotice = {};
                let callBidDoc = {};
                callBidDoc.id = self.docId;
                if(self.modifyTime) {
                    let callBidDocInfo = self.callBidDocInfo;
                    if(!Utils.isNoB(callBidDocInfo.enrollCloseTime)) {
                        callBidDoc.enrollCloseTime = callBidDocInfo.enrollCloseTime.format("yyyy-MM-dd HH:mm:ss");
                    }
                    if(!Utils.isNoB(callBidDocInfo.openTime)) {
                        callBidDoc.openTime = callBidDocInfo.openTime.format("yyyy-MM-dd HH:mm:ss");
                    }
                    if(!Utils.isNoB(callBidDocInfo.closeTime)) {
                        callBidDoc.closeTime = callBidDocInfo.closeTime.format("yyyy-MM-dd HH:mm:ss");
                    }
                    if(!Utils.isNoB(callBidDocInfo.resultPublishTime)) {
                        callBidDoc.resultPublishTime = callBidDocInfo.resultPublishTime.format("yyyy-MM-dd HH:mm:ss");
                    }

                    let now = new Date().getTime();
                    let enrollCloseTime = callBidDocInfo.enrollCloseTime;
                    let openTime = callBidDocInfo.openTime;
                    let closeTime = callBidDocInfo.closeTime;
                    let resultPublishTime = callBidDocInfo.resultPublishTime;
                    //根据不同的状态判断修改的时间是否大于当前时间
                    if(self.state < self.biding) {
                        if(enrollCloseTime != self.initialEnrollCloseTime) {
                            enrollCloseTime = new Date(enrollCloseTime).getTime();
                            if(enrollCloseTime < now) {
                                result.type = "warn";
                                result.message = "报名截至时间小于当前时间"
                                return result;
                            }
                        }
                        if(openTime != self.initialOpenTime) {
                            openTime = new Date(openTime).getTime();
                            if(openTime < now) {
                                result.type = "warn";
                                result.message = "资质预审时间小于当前时间"
                                return result;
                            }
                        }
                    }
                    if(self.state < self.openBid) {
                        if(closeTime != self.initialCloseTime) {
                            closeTime = new Date(closeTime).getTime();
                            if(closeTime < now) {
                                result.type = "warn";
                                result.message = "投标截至小于当前时间"
                                return result;
                            }
                        }
                    }
                    if(self.state <= self.openBid) {
                        if(resultPublishTime != self.initialResultPublishTime) {
                            resultPublishTime = new Date(resultPublishTime).getTime();
                            if(resultPublishTime < now) {
                                result.type = "warn";
                                result.message = "公布结果时间小于当前时间"
                                return result;
                            }
                        }
                    }
                    //判断修改的时间是否大于后一个时间
                    if(callBidDoc.enrollCloseTime >= callBidDoc.openTime) {
                        result.type = "warn";
                        result.message = "报名截至时间不能大于资质预审时间"
                        return result;
                    }
                    if(callBidDoc.openTime >= callBidDoc.closeTime) {
                        result.type = "warn";
                        result.message = "资质预审时间不能大于投标截至时间"
                        return result;
                    }
                    if(callBidDoc.closeTime >= callBidDoc.resultPublishTime) {
                        result.type = "warn";
                        result.message = "投标截至时间不能大于公布结果时间"
                        return result;
                    }
                    callBidNotice.callBidDoc = callBidDoc;
                }
                if(self.modifyFile) {
                    let fileList = self.fileList;
                    callBidDoc.callBidFileList = Utils.merge([], fileList);
                    callBidNotice.callBidDoc = callBidDoc;
                }
                callBidNotice.modifyTime = self.modifyTime;
                callBidNotice.modifyFile = self.modifyFile;
                callBidNotice.published = true;
                result.type = "info";
                result.data = callBidNotice;

                return result;
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidNoticePublish.vue